import React from 'react';
import { Button } from '@components';
import { Card, Form, Row, Col, ButtonGroup } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import { useLocation, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Get, Put } from '@app/utils/httpProvider';
import { useQuery, useQueryClient, useMutation } from 'react-query';
import Editor from '@app/components/editor/Editor';
import 'react-tabs/style/react-tabs.css';
import {
    messageError,
    messageToast,
    status200,
    role,
    objectLoaiNoiDung,
    styleSelectError,
    styleSelectDefault
} from '../../utils/define';
import {
    BaseGatewayImage,
    MATERIALCATALOG_API,
} from '../../utils/apiUrl.js';
import { useDispatch } from 'react-redux';
import HorizontalFieldsRow from '@app/components/common/HorizontalFieldsRow';

const schema = yup.object().shape({
    materialCode: yup.string().required(messageError.emptyMessage),
});

const MaterialCatalogEdit = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const queryClient = useQueryClient();
    const location = useLocation();
    const paramUrl = new URLSearchParams(location.search.substring(1));
    const itemId = paramUrl.get('id');

    // const inforAccount = getInfomationAccountFromToken();
    // let accountRoleManageDevice = false;

    // if (inforAccount && inforAccount.role) {
    //     const userRole = inforAccount.role.split(', ');
    //     accountRoleManageDevice =
    //         userRole.includes(role.Admin) || userRole.includes(role.Editor);
    //     // accountRoleBooker =
    //     //     userRole.includes(role.Admin) || userRole.includes(role.Booker);
    // }

    const itemEdit = useQuery([itemId], () =>
        Get(MATERIALCATALOG_API.GET_ITEM, itemId)
    );

    console.log("itemEdit", itemEdit);

    const editFunc = useMutation((value) =>
        Put(MATERIALCATALOG_API.UPDATE_ITEM, itemId, value)
    );

    const handleEdit = async (values) => {
        const model = { ...values };

        model.id = itemId;

        editFunc.mutate(model, {
            onSuccess: (res) => {
                if (res.status !== status200) {
                    toast.error(messageToast.messageToastUpdateError);
                } else {
                    toast.success(messageToast.messageToastUpdateSuccess);
                    // dispatch(
                    //     apiRoleMappingPagingAction({
                    //         PageIndex: 1,
                    //         PageSize: 10000
                    //     })
                    // );
                    queryClient.setQueryData(itemId, model);
                    history.goBack();
                }
            },
            onError: (res) => {
                toast.error(
                    res.message || 'Đã có lỗi xảy ra, vui lòng thử lại !'
                );
            }
        });
    };

    const isLoading = itemEdit.isLoading ? true : false;
    const isError = itemEdit.isError ? true : false;
    const error = itemEdit.isError ? itemEdit.error : null;

    return (
        <Card>
            <Card.Header as="h5">Xem hoặc sửa vật tư / linh kiện</Card.Header>
            <Card.Body>
                {isLoading ? (
                    <div>Đang tải...</div>
                ) : isError ? (
                    <div>Có lỗi xảy ra: ${error.message}</div>
                ) : itemEdit.data == null ? (
                    <div>Danh mục không tồn tại</div>
                ) : (
                    <Formik
                        enableReinitialize
                        validationSchema={schema}
                        onSubmit={(values) => handleEdit(values)}
                        initialValues={{
                            materialCode:
                                itemEdit.data && itemEdit.data.materialCode
                                    ? itemEdit.data.materialCode
                                    : '',
                            materialName:
                                itemEdit.data && itemEdit.data.materialName
                                    ? itemEdit.data.materialName
                                    : '',
                            specification:
                                itemEdit.data && itemEdit.data.specification
                                    ? itemEdit.data.specification
                                    : '',
                            unit:
                                itemEdit.data && itemEdit.data.unit
                                    ? itemEdit.data.unit
                                    : '',
                            description:
                                itemEdit.data && itemEdit.data.description
                                    ? itemEdit.data.description
                                    : '',
                        }}
                    >
                        {({
                            handleSubmit,
                            handleChange,
                            values,
                            errors,
                            touched,
                            setFieldValue
                        }) => (
                            <Form noValidate onSubmit={handleSubmit}>
                                <HorizontalFieldsRow
                                    fields={[
                                        {
                                            label: 'Code vật tư / linh kiện',
                                            name: 'materialCode',
                                            value: values.materialCode,
                                            onChange: handleChange,
                                            isInvalid: errors.materialCode && touched.materialCode,
                                            error: touched.materialCode ? errors.materialCode : null
                                        },
                                        {
                                            label: 'Tên vật tư / linh kiện',
                                            name: 'materialName',
                                            value: values.materialName,
                                            onChange: handleChange,
                                            isInvalid: errors.materialName && touched.materialName,
                                            error: touched.materialName ? errors.materialName : null
                                        }
                                    ]}
                                />
                                <HorizontalFieldsRow
                                    fields={[
                                        {
                                            label: 'Thông số kỹ thuật',
                                            name: 'specification',
                                            value: values.specification,
                                            onChange: handleChange,
                                            isInvalid: errors.specification && touched.specification,
                                            error: touched.specification ? errors.specification : null
                                        },
                                        {
                                            label: 'Đơn vị',
                                            name: 'unit',
                                            value: values.unit,
                                            onChange: handleChange,
                                            isInvalid: errors.unit && touched.unit,
                                            error: touched.unit ? errors.unit : null
                                        }
                                    ]}
                                />
                                <Form.Group as={Row} className="mb-3">
                                    <Form.Label className="col-sm-2 col-form-label">
                                        Mô tả
                                    </Form.Label>
                                    <Col sm="10">
                                        <Editor
                                            name="description"
                                            value={values.description}
                                            onChange={(value) => {
                                                setFieldValue(
                                                    'description',
                                                    value
                                                );
                                            }}
                                        />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3">
                                    <Col md={{ span: 10, offset: 2 }}>
                                        <ButtonGroup className="mb-2">
                                            <Button
                                                type="submit"
                                                theme="primary"
                                            >
                                                Sửa
                                            </Button>
                                            &nbsp;&nbsp;&nbsp;
                                            <Button
                                                onClick={() => history.goBack()}
                                                theme="secondary"
                                            >
                                                Hủy
                                            </Button>
                                        </ButtonGroup>
                                    </Col>
                                </Form.Group>
                            </Form>
                        )}
                    </Formik>
                )}
            </Card.Body>
        </Card>
    );
};

export default MaterialCatalogEdit;
